var _excluded = ["title", "price", "footer", "isActive", "customColor"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useState } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import ConditionalWrapper from "../../../helpers/ConditionalWrapper";
import useBreakpoint from "../../../hooks/useBreakpoint";
import { getBackgroundByTextColor } from "../../../utils/getCustomColor";
import TextAtm from "../../atoms/TextAtm";
import AnimateHeightOrg from "../../organisms/AnimateHeightOrg";
import PushOrg from "../../organisms/PushOrg";
import RelativeContainerOrg from "../../organisms/RelativeContainerOrg";
import { largeBreakpointValue } from "../AdvancedProductCardMol/AdvancedProductCardMol.settings";
import { ArrowIconWrapper, ButtonsWrapper, FooterWrapper, HeaderWrapper, MobileArrowIconWrapper, StyledArrowSvg, StyledCaretDownSvg, StyledFlexContainerOrg, Wrapper } from "./ProductPriceMol.styled";
function ProductPriceMol(_ref) {
  var title = _ref.title,
    price = _ref.price,
    footer = _ref.footer,
    isActive = _ref.isActive,
    customColor = _ref.customColor,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(isActive),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var isLarge = useBreakpoint(largeBreakpointValue);
  var backgroundColorValue = customColor && getBackgroundByTextColor(customColor.text) || "backgroundLight";
  var handleOnClick = function handleOnClick() {
    setIsOpen(function (value) {
      return !value;
    });
  };
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $isOpen: isOpen,
    $isActive: isActive,
    $backgroundColor: backgroundColorValue
  }, restProps), /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: backgroundColorValue
  }, /*#__PURE__*/React.createElement(StyledFlexContainerOrg, {
    direction: "column",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(HeaderWrapper, {
    onClick: !isActive ? handleOnClick : undefined
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextAtm, {
    typography: {
      small: "big3",
      medium: "big3",
      large: "big4"
    }
  }, title), /*#__PURE__*/React.createElement(PushOrg, {
    topSpace: 1
  }, price)), !isActive && /*#__PURE__*/React.createElement(MobileArrowIconWrapper, null, /*#__PURE__*/React.createElement(StyledCaretDownSvg, {
    $onColor: backgroundColorValue
  }))), /*#__PURE__*/React.createElement(ConditionalWrapper, {
    condition: !isLarge,
    wrapper: function wrapper(children) {
      return /*#__PURE__*/React.createElement(AnimateHeightOrg, {
        isOpen: isOpen
      }, children);
    }
  }, /*#__PURE__*/React.createElement(FooterWrapper, null, /*#__PURE__*/React.createElement(RelativeContainerOrg, null, /*#__PURE__*/React.createElement(ButtonsWrapper, null, footer), /*#__PURE__*/React.createElement(ArrowIconWrapper, null, /*#__PURE__*/React.createElement(StyledArrowSvg, {
    $onColor: backgroundColorValue
  }))))))));
}
export default ProductPriceMol;